module.exports = __webpack_public_path__ + "img/27)Alsenblöcke Berlin-Montage von Wandverkleidungen in über 50 Sitzungssälen.jpg";